module.exports = [{
  plugin: require('../../@mdx-deck/gatsby-plugin/gatsby-browser.js'),
  options: {
    "plugins": [],
    "path": "/opt/buildhome/repo/deck.mdx",
    "dirname": "/opt/buildhome/repo"
  }
}];